import React, { type FC, type PropsWithChildren } from 'react';

type ArrowRightProps = {
  /** The color of the icon. */
  color?: string;
};

const ArrowRight: FC<PropsWithChildren<ArrowRightProps>> = ({ color = 'currentcolor' }) => (
  <svg fill="none" height="100%" viewBox="0 0 20 15" width="100%" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1 6.5H0V8.5H1V6.5ZM18 8.5H19V6.5H18V8.5ZM18.5 7H19.5V6.54007L19.1508 6.24074L18.5 7ZM18.5 8L19.1508 8.75926L19.5 8.45993V8H18.5ZM1 8.5H18V6.5H1V8.5ZM19.1508 6.24074L12.1508 0.240743L10.8492 1.75926L17.8492 7.75926L19.1508 6.24074ZM17.8492 7.24074L10.8492 13.2407L12.1508 14.7593L19.1508 8.75926L17.8492 7.24074ZM17.5 7V8H19.5V7H17.5Z"
      fill={color}
    />
  </svg>
);

export default ArrowRight;
